import axios from "axios";
import api from "../api";

// BRASIL API
async function ba_getCep(cep) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.brasilapi.cep}${cep}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  ba_getCep,
};
